import React from 'react';
import './TDLTE.css';

const TDLTE = () => {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  const features = [
    {
      icon: '📶',
      title: 'پوشش گسترده در سراسر ایران',
      desc: 'دسترسی به اینترنت پرسرعت در تمام استان‌ها و شهرهای بزرگ ایران',
    },
    {
      icon: '🧠',
      title: 'تکنولوژی هوشمند',
      desc: 'انتخاب خودکار بهترین باند و کانال برای بالاترین کیفیت اتصال',
    },
    {
      icon: '⚡',
      title: 'نصب آسان و سریع',
      desc: 'راه‌اندازی در کمتر از ۲۴ ساعت بدون نیاز به کابل‌کشی پیچیده',
    },
    {
      icon: '💰',
      title: 'مقرون‌به‌صرفه',
      desc: 'هزینه مناسب با کیفیت بالا برای استفاده خانگی و کسب‌وکارهای کوچک',
    },
  ];

  const cities = [
    'تهران', 'اصفهان', 'شیراز', 'تبریز', 'مشهد', 'اهواز',
    'کرج', 'قشم', 'کیش', 'گرگان', 'رشت', 'کرمانشاه',
    'یزد', 'زنجان', 'ارومیه', 'بندرعباس', 'کرمان', 'همدان',
    'اراک', 'قزوین', 'سنندج', 'بوشهر', 'خرم‌آباد', 'ساری',
    'بجنورد', 'ایلام', 'شهرکرد', 'بیرجند', 'سمنان', 'زاهدان',
  ];

  const benefits = [
    {
      title: 'اینترنت بی‌سیم با کیفیت بالا',
      desc: 'بدون نیاز به کابل‌کشی، در هر نقطه از شهر به اینترنت پرسرعت دسترسی داشته باشید.',
    },
    {
      title: 'مناسب برای خانه و خانواده',
      desc: 'اینترنت با کیفیت برای تماشای فیلم، بازی آنلاین، کارهای روزمره و آموزش مجازی.',
    },
    {
      title: 'پایداری و اتصال مطمئن',
      desc: 'با تکنولوژی پیشرفته TD-LTE، همیشه به اینترنت پایدار و مطمئن متصل هستید.',
    },
    {
      title: 'پشتیبانی ۲۴/۷',
      desc: 'تیم پشتیبانی افراسل در تمام ساعات شبانه‌روز برای رفع مشکلات شما در دسترس است.',
    },
  ];

  const packages = [
    {
      name: 'بسته خانگی',
      speed: 'تا ۵۰ مگابیت',
      features: ['اینترنت نامحدود', 'مودم رایگان', 'نصب در ۲۴ ساعت', 'پشتیبانی ۲۴/۷'],
      popular: true,
    },
    {
      name: 'بسته کسب‌وکار',
      speed: 'تا ۱۰۰ مگابیت',
      features: ['اینترنت نامحدود', 'مودم حرفه‌ای', 'IP ثابت', 'پشتیبانی اولویت‌دار'],
      popular: false,
    },
    {
      name: 'بسته سازمانی',
      speed: 'تا ۲۰۰ مگابیت',
      features: ['پهنای باند اختصاصی', 'مودم پیشرفته', 'SLA تضمینی', 'پشتیبانی ۲۴/۷'],
      popular: false,
    },
  ];

  return (
    <>
      {/* SEO Header */}
      <div className="seo-header">
        <h1>اینترنت TD-LTE افراسل — پوشش گسترده در سراسر ایران</h1>
        <p>اینترنت بی‌سیم هوشمند TD-LTE با پوشش گسترده در بیش از ۳۰ شهر ایران، نصب آسان و پشتیبانی ۲۴ ساعته</p>
      </div>

      {/* Hero Section */}
      <section className="tdlte-hero">
        <div className="tdlte-hero-bg"></div>
        <div className="wrap">
          <div className="tdlte-hero-content">
            <div className="tdlte-badge">
              <span className="pulse-dot"></span>
              اینترنت هوشمند بی‌سیم
            </div>
            <h1 className="tdlte-hero-title">
              اینترنت <em>TD-LTE هوشمند</em>
            </h1>
            <p className="tdlte-hero-desc">
              اینترنت بی‌سیم با پوشش گسترده در سراسر ایران، نصب آسان و کیفیت بالا برای خانه و کسب‌وکار
            </p>
            <div className="tdlte-hero-btns">
              <button className="btn-lg primary" onClick={() => scrollTo('tdlte-features')}>
                مشاهده مزایا
              </button>
              <button className="btn-lg ghost" onClick={() => scrollTo('contact')}>
                ثبت نام اولیه ←
              </button>
            </div>
            <div className="tdlte-hero-stats">
              <div className="stat-item">
                <span className="stat-number">۳۰+</span>
                <span className="stat-label">شهر</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">۲۰۰+</span>
                <span className="stat-label">مگابیت سرعت</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">۲۴/۷</span>
                <span className="stat-label">پشتیبانی</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="tdlte-features" id="tdlte-features">
        <div className="wrap">
          <div className="sec-header">
            <span className="sec-tag">مزایای TD-LTE</span>
            <h2 className="sec-h">چرا <em>TD-LTE افراسل</em>؟</h2>
            <p className="sec-p">اینترنت بی‌سیم هوشمند با پوشش گسترده و کیفیت بالا</p>
          </div>
          <div className="tdlte-features-grid">
            {features.map((feature, i) => (
              <div key={i} className="tdlte-feature-card">
                <span className="tdlte-feature-icon">{feature.icon}</span>
                <h3 className="tdlte-feature-title">{feature.title}</h3>
                <p className="tdlte-feature-desc">{feature.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="tdlte-benefits">
        <div className="wrap">
          <div className="sec-header">
            <span className="sec-tag">مزایا</span>
            <h2 className="sec-h">اینترنت TD-LTE برای <em>چه کسانی</em>؟</h2>
            <p className="sec-p">راه‌حلی ایده‌آل برای خانه، کسب‌وکار و سازمان‌های کوچک</p>
          </div>
          <div className="tdlte-benefits-grid">
            {benefits.map((benefit, i) => (
              <div key={i} className="tdlte-benefit-card">
                <div className="tdlte-benefit-icon">✓</div>
                <div>
                  <h3 className="tdlte-benefit-title">{benefit.title}</h3>
                  <p className="tdlte-benefit-desc">{benefit.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Packages Section */}
      <section className="tdlte-packages">
        <div className="wrap">
          <div className="sec-header">
            <span className="sec-tag">بسته‌ها</span>
            <h2 className="sec-h">بسته‌های <em>اینترنت TD-LTE</em></h2>
            <p className="sec-p">انتخاب بسته مناسب بر اساس نیاز شما</p>
          </div>
          <div className="tdlte-packages-grid">
            {packages.map((pkg, i) => (
              <div key={i} className={`tdlte-package ${pkg.popular ? 'package-popular' : ''}`}>
                {pkg.popular && <div className="package-popular-badge">پرفروش‌ترین</div>}
                <h3 className="package-name">{pkg.name}</h3>
                <div className="package-speed">{pkg.speed}</div>
                <ul className="package-features">
                  {pkg.features.map((feat, j) => (
                    <li key={j}><span>✓</span> {feat}</li>
                  ))}
                </ul>
                <button className="package-order-btn" onClick={() => scrollTo('contact')}>
                  ثبت نام اولیه
                </button>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Coverage Section */}
      <section className="tdlte-coverage">
        <div className="wrap">
          <div className="sec-header">
            <span className="sec-tag">پوشش</span>
            <h2 className="sec-h">شهرهای تحت پوشش <em>TD-LTE</em></h2>
            <p className="sec-p">اینترنت هوشمند افراسل در بیش از ۳۰ شهر بزرگ ایران</p>
          </div>
          <div className="tdlte-coverage-grid">
            <div className="tdlte-coverage-tags">
              {cities.map((city, i) => (
                <span key={i} className="tdlte-city-tag">{city}</span>
              ))}
            </div>
            <p className="tdlte-coverage-note">* لیست شهرها در حال تکمیل است. برای استعلام دقیق با ما تماس بگیرید</p>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="tdlte-cta">
        <div className="wrap">
          <div className="cta-box">
            <h2 className="cta-title">
              اینترنت <em>هوشمند</em> را تجربه کنید
            </h2>
            <p className="cta-desc">
              همین حالا ثبت نام اولیه را انجام دهید و از اینترنت پرسرعت TD-LTE افراسل بهره‌مند شوید
            </p>
            <div className="cta-btns">
              <button className="btn-lg primary" onClick={() => scrollTo('contact')}>
                ثبت نام اولیه
              </button>
              <button className="btn-lg ghost" onClick={() => scrollTo('contact')}>
                مشاوره رایگان
              </button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default TDLTE;
